import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';
import { fetchMe } from 'redux/users/actions';
import {
  fetchCommerceLinksList,
  createStripeAccount,
  clearCreateStripeAccount,
} from 'redux/commerce/actions';

import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import { SITE_URL, STRIPE_CLIENT_ID } from 'utils/restapi';

import './ConnectStripeStep3.css';

function ConnectStripeStep3(props) {
  const {
    fetchMe,
    fetchCommerceLinksList,
    createStripeAccount,
    clearCreateStripeAccount,
    setActiveStep,
    stripeCountry,
    stripeCurrency,
    createStripeAccountSuccess,
    createStripeAccountError,
    onClose,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    if (createStripeAccountSuccess) {
      fetchMe();
      fetchCommerceLinksList();
    }
  }, [createStripeAccountSuccess]);

  const connectStripeUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${STRIPE_CLIENT_ID}&scope=read_write&state=${stripeCurrency}&redirect_uri=${SITE_URL}/stripe-connect`;

  const createNewStripeAccount = () => {
    createStripeAccount({
      country_id: stripeCountry,
      currency_id: stripeCurrency,
    });
  };

  if (createStripeAccountSuccess) {
    return (
      <div className="connect-stripe-step3__component">
        <div className="success-wrapper">
          <div className="success-logo" />
          <div className="header">{t("Connected to Stripe!")}</div>
          <div className="text">
            {t("Congratulations! You have successfully connected your " +
               "new Stripe account. Now you can collect payments, tips or donations.")}
          </div>
          <div className="onboarding">
            <span className="alert">{t("Payments are currently disabled.")}</span><br/>
            {t("To enable payments please")} <a href={createStripeAccountSuccess.account_link.url}>{t("follow the onboarding flow")}</a>.
          </div>
          <Button
            small
            borderedBlue
            onClick={onClose}
          >
            {t("OK")}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="connect-stripe-step3__component">
      <div className="header">
        {t("Create New or Connect Existing Stripe")}
      </div>

      <div className="text">
        {t("In order to collect payments and deposit the funds to your bank account, we partnered with Stripe:")}
      </div>

      <div className="buttons-block">
        <a href={connectStripeUrl}>
          <Button>
            {t("Connect an existing Stripe account")}
          </Button>
        </a>

        <div className="divider">
          <div className="or">{t("or")}</div>
        </div>

        <Button
          borderedBlue
          onClick={createNewStripeAccount}
        >
          {t("Create a new Stripe account")}
        </Button>
      </div>

      {createStripeAccountError &&
        <CommonMessage
          error
          errors={createStripeAccountError}
        />
      }

      <div className="back-button">
        <Button
          small
          borderedBlue
          onClick={() => {
            setActiveStep('stripe-step-2');
            clearCreateStripeAccount();
          }}
        >
          &#10094;&nbsp;&nbsp;{t("Back")}
        </Button>
      </div>

    </div>
  );
}

ConnectStripeStep3.propTypes = {
  onClose: PropTypes.func.isRequired,
  fetchMe: PropTypes.func.isRequired,
  fetchCommerceLinksList: PropTypes.func.isRequired,
  createStripeAccount: PropTypes.func.isRequired,
  clearCreateStripeAccount: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
  stripeCountry: PropTypes.number.isRequired,
  stripeCurrency: PropTypes.number.isRequired,
  createStripeAccountSuccess: PropTypes.object,
  createStripeAccountError: PropTypes.object,
};

ConnectStripeStep3.defaultProps = {
  createStripeAccountSuccess: null,
  createStripeAccountError: null,
};

const mapStateToProps = state => (
  {
    createStripeAccountSuccess: state.commerceReducer.createStripeAccountSuccess,
    createStripeAccountError: state.commerceReducer.createStripeAccountError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchMe,
    fetchCommerceLinksList,
    createStripeAccount,
    clearCreateStripeAccount,
  },
)(ConnectStripeStep3);
